var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { timelineSelector, getTimeline, getPrograms, getDefaultTimeline, setProgramDetails, getAllPlansForProgram, deleteLicensurePlan, updateTimeline, closeSnackbar, setButtonAction, getTimelineCopy, openDeletePlanModal, openArchivePlanModal, getTimlinesForProgram, } from "./TimelineSlice";
import { cohortSelector } from "../cohorts/CohortSlice";
import { useSelector, useDispatch } from "react-redux";
import Header from "../common/header/Header";
import SideNav from "../common/sidenav/SideNav";
import { WmTabPanel, WmButton, WmSnackbar, WmActionMenu, WmMenuitem, WmSearch, WmSelect, WmOption, } from "@watermarkinsights/ripple-react";
import { getI18nValueByKey, } from "../common/commonActions";
import { useEffect, useState } from "react";
import SubTabWmComponent from "../common/component/SubTabsWmComponent";
import { focusActionMenuComponent, focusButtonComponent, } from "../../static/js/commons.js";
import CohortCards from "../cohorts/CohortCards";
import translate from "../../i18n/translate";
import { resetPublishCohortID } from "../cohorts/CohortSlice";
import { getLoggedInUserInfo, userSelector, } from "../../features/login/UserSlice";
import Footer from "../../features/common/footer/Footer";
import { format } from "date-fns";
import { useIntl } from "react-intl";
import { PlanStatus } from "../cohorts/data/PlanStatus";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DeleteModal from "../../features/common/component/DeleteWmModal";
import DiscardModal from "../../features/common/component/DiscardWmModal";
import InformationModal from "../../features/common/component/InformationWmModal";
import ViewPlan from "./ViewPlan";
export default function ViewLicensurePlan(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    let { programUuid } = useParams();
    const { timelineData, currentProgramData, isFetchingTimeline, isFetchingCurrentProgram, isFetchingAllPrograms, programPlansData, snackNotifications, isCopyCompleted, displayDeletePlanModal, deletedPlanIndex, displayArchivePlanModal, archivedPlanIndex, } = useSelector(timelineSelector);
    const { publishingCohort, publishingCohortUuid, publishingCohortTitle, publishingCohortReleaseDate, publishingCohortSendNotification, cohortList, } = useSelector(cohortSelector);
    const { userInfo } = useSelector(userSelector);
    const timelineSections = timelineData.sections;
    document.title = ((_a = location.state) === null || _a === void 0 ? void 0 : _a.programTitle) + " | Watermark";
    let [selectedTab, setselectedTab] = useState(((_b = location.state) === null || _b === void 0 ? void 0 : _b.currentTab) ? (_c = location.state) === null || _c === void 0 ? void 0 : _c.currentTab : "item-1");
    const [timelineUuid, setTimelineUuid] = useState((_d = location.state) === null || _d === void 0 ? void 0 : _d.timelineUuid);
    const [isCreatePlanClicked, setIsCreatePlanClicked] = useState(false);
    const [copiedFromPlanUuid, setCopiedFromPlanUuid] = useState((_e = location.state) === null || _e === void 0 ? void 0 : _e.copiedFromTimelineUuid);
    const [viewPlan, setViewPlan] = useState(false);
    const [planId, setPlanId] = useState("");
    useEffect(() => {
        var _a;
        if (copiedFromPlanUuid && ((_a = location.state) === null || _a === void 0 ? void 0 : _a.previousPage) === "?copy") {
            setTimeout(() => {
                focusActionMenuComponent(`action-menu-${copiedFromPlanUuid}`);
            }, 1000);
        }
    }, [copiedFromPlanUuid]);
    const [showArchivedPlans, setShowArchivedPlans] = useState(((_g = (_f = location.state) === null || _f === void 0 ? void 0 : _f.listingPageFilters) === null || _g === void 0 ? void 0 : _g.showArchivedPlans)
        ? (_j = (_h = location.state) === null || _h === void 0 ? void 0 : _h.listingPageFilters) === null || _j === void 0 ? void 0 : _j.showArchivedPlans
        : false);
    let filterValues = (_k = location.state) === null || _k === void 0 ? void 0 : _k.filterValues;
    const [isPlanLimitExceed, setIsPlanLimitExceed] = useState(false);
    let [searchText, setSearchText] = useState(filterValues ? filterValues.searchText : "");
    const [selectedLicensurePlanUuid, setSelectedLicensurePlanUuid] = useState("");
    const [selectedLicensurePlanTitle, setSelectedLicensurePlanTitle] = useState("");
    const [isArchiveButtonClicked, setIsArchiveButtonClicked] = useState(false);
    const [renderFilteredPlans, setRenderFilteredPlans] = useState(programPlansData);
    const [sortPlans, setSortPlans] = useState({
        sortBy: "Title",
        isAscending: true,
    });
    const [resetFilters, setResetFilters] = useState(0);
    const [selectedCohorts, setSelectedCohorts] = useState(((_m = (_l = location.state) === null || _l === void 0 ? void 0 : _l.listingPageFilters) === null || _m === void 0 ? void 0 : _m.selectedCohorts)
        ? (_p = (_o = location.state) === null || _o === void 0 ? void 0 : _o.listingPageFilters) === null || _p === void 0 ? void 0 : _p.selectedCohorts
        : []);
    const [filterSelectedPlanStatus, setFilterSelectedPlanStatus] = useState(((_r = (_q = location.state) === null || _q === void 0 ? void 0 : _q.listingPageFilters) === null || _r === void 0 ? void 0 : _r.filterSelectedPlanStatus)
        ? (_t = (_s = location.state) === null || _s === void 0 ? void 0 : _s.listingPageFilters) === null || _t === void 0 ? void 0 : _t.filterSelectedPlanStatus
        : []);
    const [openDeleteRequestModal, setOpenDeleteRequestModal] = useState(false);
    const [openArchiveRequestModal, setOpenArchiveRequestModal] = useState(false);
    const [isLicensurePlanMaxLimitReached, setIsLicensurePlanMaxLimitReached] = useState(false);
    const doesRequirementExist = (section) => section.subSections.some((subSection) => {
        return subSection.requirements.length > 0;
    });
    const onWmTabSelected = (event) => {
        dispatch(resetPublishCohortID());
        setselectedTab(event.detail.tabId);
        setSearchText("");
    };
    const toggleSwitchHandler = (event) => {
        setShowArchivedPlans((showArchivedPlans) => !showArchivedPlans);
    };
    useEffect(() => {
        if (programPlansData.length > 100) {
            setIsPlanLimitExceed(true);
        }
    });
    useEffect(() => {
        var _a, _b;
        if (!userInfo.gatewaysUser) {
            dispatch(getLoggedInUserInfo());
        }
        const orgUuid = localStorage.getItem("orgUuid");
        dispatch(getPrograms({ orgUuid, programUuid }));
        if ((_a = location.state) === null || _a === void 0 ? void 0 : _a.focusButtonEl) {
            setTimeout(() => focusButtonComponent("edit-licensure-plan"), 100);
        }
        if (!viewPlan) {
            if ((_b = location.state) === null || _b === void 0 ? void 0 : _b.currentReqUuid) {
                setTimeout(() => {
                    var _a;
                    const requirementLink = document.getElementById("req-button-id-" + ((_a = location.state) === null || _a === void 0 ? void 0 : _a.currentReqUuid));
                    requirementLink === null || requirementLink === void 0 ? void 0 : requirementLink.focus();
                }, 100);
            }
            return () => {
                dispatch(resetPublishCohortID());
            };
        }
    }, []);
    useEffect(() => {
        if (!publishingCohort) {
            setTimeout(() => focusButtonComponent("publish-button-" + publishingCohortUuid), 100);
        }
        setTimeout(() => focusButtonComponent("edit-schedule-" + publishingCohortUuid), 100);
    }, [publishingCohort]);
    useEffect(() => {
        if (planId !== "") {
            dispatch(getTimeline(planId)).then(() => {
                setViewPlan(true);
            });
        }
    }, [planId]);
    useEffect(() => {
        if (!viewPlan) {
            setPlanId("");
        }
    }, [viewPlan]);
    let searchPlaceholdler = useIntl().formatMessage({
        id: "app.licensurePlans.searchPlaceHolder",
    });
    let associatedCohortsLabel = useIntl().formatMessage({
        id: "app.licensurePlans.dropdown.associatedCohorts.label",
    });
    let planStatusLabel = useIntl().formatMessage({
        id: "app.licensurePlans.dropdown.planstatus.label",
    });
    let deleteModalHeading = useIntl().formatMessage({
        id: "app.viewLicensurePlan.dialogbox.delete.plan.heading",
    });
    let deleteModalSubHeading = useIntl().formatMessage({
        id: "app.viewLicensurePlan.dialogbox.delete.plan.sub-heading",
    });
    let archiveModalHeading = useIntl().formatMessage({
        id: "app.viewLicensurePlan.dialogbox.archive.plan.heading",
    });
    let archiveModalSubHeading = useIntl().formatMessage({
        id: "app.viewLicensurePlan.dialogbox.archive.plan.sub-heading",
    });
    let restoreModalHeading = useIntl().formatMessage({
        id: "app.viewLicensurePlan.dialogbox.restore.plan.heading",
    });
    let restoreModalSubHeading = useIntl().formatMessage({
        id: "app.viewLicensurePlan.dialogbox.restore.plan.sub-heading",
    });
    let planStatusChangeLableValue = useIntl().formatMessage({
        id: "app.viewLicensurePlan.dialogbox.change.plan.status.lableValue",
    });
    let deletePlanLableValue = useIntl().formatMessage({
        id: "app.viewLicensurePlan.dialogbox.delete.plan.lableValue",
    });
    let allPlanStatusValue = useIntl().formatMessage({
        id: "app.licensurePlans.filterPlanStatus.all",
    });
    let allAssociatedCohortsValue = useIntl().formatMessage({
        id: "app.licensurePlans.filterCohorts.all",
    });
    let primaryTextArchiveValue = useIntl().formatMessage({
        id: "app.cohort.discardModal.primaryText.archive",
    });
    let primaryTextRestoreValue = useIntl().formatMessage({
        id: "app.cohort.discardModal.primaryText.restore",
    });
    let infoDialogboxHeading = useIntl().formatMessage({
        id: "app.viewLicensurePlan.info.dialogbox.heading",
    });
    const finishedSnackHandler = (event) => {
        event.preventDefault();
        dispatch(closeSnackbar(event.detail.id));
    };
    const editLicensurePlanHandler = (event) => {
        setIsCreatePlanClicked(false);
        navigate({
            pathname: "/programs/" + currentProgramData.uuid + "/timeline/" + event.uuid,
            search: "?edit",
        }, {
            state: {
                programTitle: currentProgramData.title,
                timelineUuid: event.uuid,
                listingPageFilters: {
                    filterSelectedPlanStatus,
                    selectedCohorts,
                    showArchivedPlans,
                },
            },
        });
        focusButtonComponent("edit-timeline-title");
    };
    const copyLicensurePlanHandler = (event) => __awaiter(this, void 0, void 0, function* () {
        if (programPlansData.length >= 100) {
            setIsLicensurePlanMaxLimitReached(true);
        }
        else {
            yield Promise.all([dispatch(getTimelineCopy(event.uuid))]);
        }
        focusButtonComponent("edit-timeline-title");
    });
    const tabOption = [
        {
            name: "COHORTS",
            id: "tab1",
        },
        {
            name: "LICENSURE PLANS",
            id: "tab2",
        },
    ];
    const navigateToLandingPage = (event) => {
        event.preventDefault();
        navigate("/licensurePlans");
    };
    const openRequirementHandler = (event, requirement, type) => {
        event.preventDefault();
        navigate({
            pathname: "/timeline/" + timelineUuid + "/requirement/" + requirement.uuid,
        }, {
            state: {
                requirement: requirement,
                type: type,
                currentProgramData: currentProgramData,
                timelineUuid: timelineData.uuid,
            },
        });
    };
    const [isCreate, setIsCreate] = useState(false);
    const getAriaSortValue = (columnName, records) => {
        if (columnName !== records.sortBy) {
            return "none";
        }
        return records.isAscending ? "ascending" : "descending";
    };
    const sortingIcon = (field, records) => {
        return records.sortBy == field ? (records.isAscending ? (_jsx("span", Object.assign({ className: "mdi mdi-arrow-down-bold" }, { children: " " }))) : (_jsx("span", Object.assign({ className: "mdi mdi-arrow-up-bold" }, { children: " " })))) : ("");
    };
    const createLicensurePlanHandler = (event) => __awaiter(this, void 0, void 0, function* () {
        const data = {
            programUuid: currentProgramData.uuid,
            programName: currentProgramData.title,
        };
        if (programPlansData.length >= 100) {
            setIsLicensurePlanMaxLimitReached(true);
        }
        else {
            yield Promise.all([dispatch(getDefaultTimeline(data))]);
            setIsCreate(true);
            setIsCreatePlanClicked(true);
        }
    });
    const changeSorting = (field, records) => {
        const newSort = records.sortBy == field ? (records.isAscending ? false : true) : true;
        setSortPlans({
            sortBy: field,
            isAscending: newSort,
        });
    };
    const keyEventHandler = (event, columnName, records) => {
        event.preventDefault();
        const keyCode = event.keyCode ? event.keyCode : event.which;
        if (keyCode == "13") {
            changeSorting(columnName, records);
        }
    };
    const searchTextHandler = (event) => {
        event.preventDefault();
        setSearchText(event.target.value);
    };
    const getSearchedPlans = (plans, searchText) => {
        return plans.filter((plan) => {
            return plan.title.toLowerCase().includes(searchText.toLowerCase());
        });
    };
    const [uniqueCohorts, setUniqueCohorts] = useState([
        ...Array.from(new Set(programPlansData === null || programPlansData === void 0 ? void 0 : programPlansData.map((plan) => {
            var _a;
            return (_a = plan === null || plan === void 0 ? void 0 : plan.cohorts) === null || _a === void 0 ? void 0 : _a.map((cohort) => {
                return cohort.title;
            });
        })))
            .flat()
            .sort(),
    ]);
    const sortedUniqueCohorts = (uniqueCohorts) => {
        return uniqueCohorts.sort((a, b) => {
            a = a.toLowerCase();
            b = b.toLowerCase();
            if (a == b)
                return 0;
            return a < b ? -1 : 1;
        });
    };
    const getPlansByCohorts = (planList) => {
        if (selectedCohorts.length === 0) {
            return planList;
        }
        else {
            return planList.filter((plan) => plan.cohorts.some((cohort) => {
                return selectedCohorts.some((selectedCohort) => cohort.title === selectedCohort);
            }));
        }
    };
    const getPlansByStatus = (planList) => {
        if (filterSelectedPlanStatus.length === 0) {
            if (showArchivedPlans) {
                return planList;
            }
            else {
                return planList.filter((plan) => plan.status !== "ARCHIVED");
            }
        }
        else {
            let filterStatuses = [...filterSelectedPlanStatus];
            if (showArchivedPlans) {
                filterStatuses.push("ARCHIVED");
            }
            return planList.filter((plan) => filterStatuses.some((selectedPlan) => plan.status === selectedPlan));
        }
    };
    useEffect(() => {
        if (!displayDeletePlanModal && deletedPlanIndex != -1) {
            if ((programPlansData === null || programPlansData === void 0 ? void 0 : programPlansData.length) > 0) {
                if ((programPlansData === null || programPlansData === void 0 ? void 0 : programPlansData.length) === 1) {
                    focusActionMenuComponent("action-menu-" + programPlansData[0].uuid);
                }
                else {
                    if ((programPlansData === null || programPlansData === void 0 ? void 0 : programPlansData.length) === deletedPlanIndex) {
                        setTimeout(() => {
                            focusActionMenuComponent("action-menu-" + programPlansData[deletedPlanIndex - 1].uuid);
                        }, 100);
                    }
                    else {
                        setTimeout(() => {
                            focusActionMenuComponent("action-menu-" + programPlansData[deletedPlanIndex].uuid);
                        }, 100);
                    }
                }
            }
        }
    }, [displayDeletePlanModal]);
    useEffect(() => {
        if (!displayArchivePlanModal && archivedPlanIndex != -1) {
            if ((programPlansData === null || programPlansData === void 0 ? void 0 : programPlansData.length) > 0) {
                if ((programPlansData === null || programPlansData === void 0 ? void 0 : programPlansData.length) === 1) {
                    focusActionMenuComponent("action-menu-" + programPlansData[0].uuid);
                }
                else {
                    if ((programPlansData === null || programPlansData === void 0 ? void 0 : programPlansData.length) === archivedPlanIndex) {
                        setTimeout(() => {
                            focusActionMenuComponent("action-menu-" + programPlansData[archivedPlanIndex - 1].uuid);
                        }, 100);
                    }
                    else {
                        setTimeout(() => {
                            focusActionMenuComponent("action-menu-" + programPlansData[archivedPlanIndex].uuid);
                        }, 100);
                    }
                }
            }
        }
    }, [displayArchivePlanModal]);
    const closeDeleteModalHandler = (event) => {
        event.preventDefault();
        setOpenDeleteRequestModal(false);
        dispatch(openDeletePlanModal({
            displayDeletePlanModal: false,
        }));
        focusActionMenuComponent("action-menu-" + selectedLicensurePlanUuid);
    };
    const closeArchiveModalHandler = (event) => {
        event.preventDefault();
        setOpenArchiveRequestModal(false);
        dispatch(openArchivePlanModal({
            displayArchivePlanModal: false,
        }));
        focusActionMenuComponent("action-menu-" + selectedLicensurePlanUuid);
    };
    const deleteLicensurePlanHandler = (event, timelineUuid, programUuid) => __awaiter(this, void 0, void 0, function* () {
        const orgUuid = localStorage.getItem("orgUuid");
        event.preventDefault();
        dispatch(deleteLicensurePlan({ programUuid, timelineUuid }));
        setOpenDeleteRequestModal(false);
    });
    const changeLicensureStatusHandler = (event, timelineUuid, title) => {
        let status;
        if (isArchiveButtonClicked) {
            status = "ARCHIVED";
        }
        else {
            status = "RESTORE";
        }
        event.preventDefault();
        dispatch(updateTimeline({ timelineUuid, title, status }));
        setOpenArchiveRequestModal(false);
    };
    const renderViewPlan = () => {
        return (_jsx(ViewPlan, { timelineUuid: planId, programUuid: currentProgramData.uuid, archivedView: true, setViewPlan: setViewPlan }));
    };
    const renderDeleteLicensurePlanModal = (isOpen) => {
        let currentTimelineUuid = selectedLicensurePlanUuid;
        return (_jsx(DeleteModal, { isOpen: isOpen, onPrimaryClick: (event) => {
                deleteLicensurePlanHandler(event, currentTimelineUuid, currentProgramData.uuid);
            }, onSecondaryClick: closeDeleteModalHandler, modalHeading: deleteModalHeading, modalContent: deleteModalSubHeading, ariaLabelValue: deletePlanLableValue, modalId: "delete-modal", contentId: "content-delete-modal" }));
    };
    const renderInformationModal = (isOpen) => {
        var _a, _b, _c;
        let modalContent = (_jsxs("div", Object.assign({ className: "count", "aria-live": "polite", "aria-atomic": true }, { children: [translate("app.viewLicensurePlan.info.dialogbox.lableValue", {
                    planName: String(currentProgramData.title),
                }), _jsxs("a", Object.assign({ className: "licensurePlan-support-link", href: (_c = (_b = (_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.sllUser) === null || _a === void 0 ? void 0 : _a.navigation) === null || _b === void 0 ? void 0 : _b.footer) === null || _c === void 0 ? void 0 : _c.customer_support, target: "_blank" }, { children: [translate("app.error.contactSupportText"), " ", _jsx("span", { className: "mdi mdi-open-in-new" })] }))] })));
        let ariaLabelValue = "Licensure Plan Max Limit";
        return (_jsx(InformationModal, { isOpen: isOpen, onPrimaryClick: () => setIsLicensurePlanMaxLimitReached(false), modalContent: modalContent, modalHeading: infoDialogboxHeading, ariaLabelValue: ariaLabelValue, modalId: "information-modal", contentId: "content-information-modal" }));
    };
    const renderArchiveRestoreLicensurePlanModal = (isOpen) => {
        let currentTimelineUuid = selectedLicensurePlanUuid;
        let title = selectedLicensurePlanTitle;
        let primaryTextValue;
        let modalHeadingValue;
        let modalContentValue;
        if (isArchiveButtonClicked) {
            primaryTextValue = primaryTextArchiveValue;
            modalHeadingValue = archiveModalHeading;
            modalContentValue = archiveModalSubHeading;
        }
        else {
            primaryTextValue = primaryTextRestoreValue;
            modalHeadingValue = restoreModalHeading;
            modalContentValue = restoreModalSubHeading;
        }
        return (_jsx(DiscardModal, { isOpen: isOpen, onPrimaryClick: (event) => {
                changeLicensureStatusHandler(event, currentTimelineUuid, title);
            }, onSecondaryClick: closeArchiveModalHandler, modalHeading: modalHeadingValue, modalContent: modalContentValue, ariaLabelValue: planStatusChangeLableValue, modalId: "archive-modal", contentId: "content-archive-modal", primaryText: primaryTextValue, secondayText: "Cancel", onClose: closeArchiveModalHandler }));
    };
    const openDeleteModal = (event, currentTimelineUuid, title) => {
        event.preventDefault();
        setOpenDeleteRequestModal(true);
        dispatch(setButtonAction({ title: title, action: "DELETE" }));
        dispatch(openDeletePlanModal({
            displayDeletePlanModal: true,
        }));
    };
    const openArchiveModal = (event, currentTimelineUuid, selectedTitle, isArchiveButtonClicked, title) => {
        event.preventDefault();
        setOpenArchiveRequestModal(true);
        if (isArchiveButtonClicked) {
            dispatch(setButtonAction({
                title: title,
                action: "ARCHIVED",
            }));
        }
        else {
            dispatch(setButtonAction({
                title: title,
                action: "RESTORE",
            }));
        }
        dispatch(openArchivePlanModal({
            displayArchivePlanModal: true,
        }));
    };
    useEffect(() => {
        let sortedPlans = [...renderFilteredPlans];
        if (sortPlans.sortBy === "Title") {
            sortedPlans.sort((a, b) => {
                return a.title.localeCompare(b.title);
            });
        }
        else if (sortPlans.sortBy === "Status") {
            sortedPlans.sort((a, b) => {
                if (sortPlans.sortBy === "Status" && a.status && b.status) {
                    return a.status.localeCompare(b.status);
                }
                return 0;
            });
        }
        else {
            sortedPlans.sort((a, b) => {
                return a.updatedAt.localeCompare(b.updatedAt);
            });
        }
        setRenderFilteredPlans(sortPlans.isAscending ? sortedPlans : sortedPlans.reverse());
    }, [sortPlans]);
    useEffect(() => {
        setRenderFilteredPlans(getSearchedPlans(getPlansByStatus(getPlansByCohorts(programPlansData)), searchText));
        setUniqueCohorts([
            ...Array.from(new Set(programPlansData === null || programPlansData === void 0 ? void 0 : programPlansData.map((plan) => {
                var _a;
                return (_a = plan === null || plan === void 0 ? void 0 : plan.cohorts) === null || _a === void 0 ? void 0 : _a.map((cohort) => {
                    return cohort.title;
                });
            })))
                .flat()
                .sort(),
        ]);
    }, [
        searchText,
        showArchivedPlans,
        filterSelectedPlanStatus,
        programPlansData,
        selectedCohorts,
    ]);
    useEffect(() => {
        if (isCreate) {
            navigate({
                pathname: "/programs/" +
                    currentProgramData.uuid +
                    "/timeline/" +
                    timelineData.uuid,
                search: "?create",
            }, {
                state: {
                    programTitle: currentProgramData.title,
                    listingPageFilters: {
                        filterSelectedPlanStatus,
                        selectedCohorts,
                        showArchivedPlans,
                    },
                },
            });
            focusButtonComponent("edit-timeline-title");
        }
    }, [isCreate]);
    useEffect(() => {
        if (isCopyCompleted) {
            navigate({
                pathname: "/programs/" +
                    currentProgramData.uuid +
                    "/timeline/" +
                    timelineData.uuid,
                search: "?copy",
            }, {
                state: {
                    programTitle: timelineData.title,
                    timelineUuid: timelineData.uuid,
                    copiedFromTimelineUuid: timelineData.copiedFromTimelineUuid,
                    listingPageFilters: {
                        filterSelectedPlanStatus,
                        selectedCohorts,
                        showArchivedPlans,
                    },
                },
            });
        }
        setTimelineUuid(timelineData.uuid !== undefined
            ? timelineData.uuid
            : currentProgramData.timelineUuid);
        setCopiedFromPlanUuid(timelineData.copiedFromTimelineUuid !== undefined
            ? timelineData.copiedFromTimelineUuid
            : currentProgramData.copiedFromTimelineUuid);
        dispatch(setProgramDetails({
            uuid: currentProgramData.uuid,
            organizationName: currentProgramData.institutionName,
            title: currentProgramData.title,
            timelineUuid: timelineData.uuid !== undefined
                ? timelineData.uuid
                : currentProgramData.timelineUuid,
        }));
    }, [timelineData, isCopyCompleted]);
    const renderLicensurePlans = () => __awaiter(this, void 0, void 0, function* () {
        const orgUuid = localStorage.getItem("orgUuid");
        yield Promise.all([
            dispatch(getAllPlansForProgram({ orgUuid, programUuid })),
            dispatch(getTimlinesForProgram({ orgUuid, programUuid })),
        ]);
    });
    useEffect(() => {
        setTimelineUuid(currentProgramData.timelineUuid);
    }, [currentProgramData]);
    useEffect(() => {
        renderLicensurePlans();
    }, []);
    const renderEmptyView = () => {
        return (_jsxs("div", Object.assign({ className: "empty-cohort-view" }, { children: [_jsx("div", Object.assign({ className: "no-students-label" }, { children: translate("app.gatewaysLandingPage.noMatch") })), _jsx("div", Object.assign({ className: "no-students-info" }, { children: translate("app.gatewaysLandingPage.adjustAndTryAgain") }))] })));
    };
    const renderLicensurePlan = () => {
        var _a;
        let currentProgramDataSize = Object.keys(currentProgramData).length;
        return (_jsxs("div", Object.assign({ className: "licensure-plan-main" }, { children: [isFetchingAllPrograms ? (_jsx("div", Object.assign({ className: "loader -fullscreen" }, { children: _jsx("div", Object.assign({ className: "content content-loader", role: "alert" }, { children: "Loading..." })) }))) :
                    !programPlansData.length ? (_jsxs("div", Object.assign({ className: "no-licensure-plan" }, { children: [_jsx("i", { className: "btn-align -icon mdi mdi-folder-clock-outline" }), _jsx("div", Object.assign({ className: "title" }, { children: translate("app.licensurePlans.noPlans") })), _jsx("div", Object.assign({ className: "helper-text" }, { children: translate("app.licensurePlans.noPlans.desc") })), _jsx(WmButton, Object.assign({ buttonType: "primary", id: "create-licensure-plan", className: "create-plan-btn", onClick: (event) => createLicensurePlanHandler(event), placeholder: undefined }, { children: translate("app.licensurePlans.createPlan") }))] }))) : (""), currentProgramDataSize < 30 && !isCreatePlanClicked ? (programPlansData.length ? (_jsxs("div", Object.assign({ className: "licensureplan-sub-tab" }, { children: [_jsxs("div", Object.assign({ className: "flex-row -verticallycentered -justified " }, { children: [_jsx("div", Object.assign({ className: "licensureplan-heading flex-row -verticallycentered -justified " }, { children: _jsx("h2", Object.assign({ className: "licensureplan-label" }, { children: translate("app.licensurePlanLandingPage.heading") })) })), _jsxs("div", Object.assign({ className: "licensureplan-header-btns flex-row -verticallycentered -justified " }, { children: [_jsxs("div", Object.assign({ className: "show-archived-plans flex-row -verticallycentered -justified" }, { children: [_jsxs("span", Object.assign({ className: "toggle-switch" }, { children: [_jsx("input", { id: "chk-archive-plans", type: "checkbox", checked: showArchivedPlans, onChange: (event) => {
                                                                toggleSwitchHandler(event);
                                                            } }), _jsx("label", Object.assign({ className: "switchtoggle", htmlFor: "chk-archive-plans", "aria-label": "Show Archived Plans" }, { children: !showArchivedPlans ? (_jsx("span", Object.assign({ className: "toggle-text" }, { children: translate("app.licensurePlans.toggle.off") }))) : (_jsx("span", Object.assign({ className: "toggle-text on" }, { children: translate("app.licensurePlans.toggle.on") }))) }))] })), _jsx("span", Object.assign({ className: "switch-label" }, { children: translate("app.licensurePlans.showArchivedPlansText") }))] })), _jsx(WmButton, Object.assign({ buttonType: "primary", id: "create-licensure-plan", onClick: (event) => createLicensurePlanHandler(event), placeholder: undefined }, { children: translate("app.licensurePlans.createPlan") }))] }))] })), _jsxs("div", Object.assign({ className: "search-select-section flex-row " }, { children: [_jsx("div", Object.assign({ className: "search-bar" }, { children: _jsx(WmSearch, { id: "search-licensure-plan", class: "student-search", placeholder: searchPlaceholdler, label: searchPlaceholdler, onInput: (event) => searchTextHandler(event), numResults: renderFilteredPlans.length, value: searchText }) })), _jsx("span", Object.assign({ className: "filter-label" }, { children: translate("app.cohort.filterBy") })), _jsx("div", Object.assign({ className: "filter-by" }, { children: _jsx(WmSelect, Object.assign({ multiple: true, id: "status-select-filter", label: planStatusLabel, labelPosition: "none", placeholder: allPlanStatusValue, allSelectedMessage: allPlanStatusValue }, { children: PlanStatus === null || PlanStatus === void 0 ? void 0 : PlanStatus.map((status) => {
                                            if (status.key === "ARCHIVED") {
                                                return "";
                                            }
                                            return (_jsx(WmOption, Object.assign({ "aria-label": getI18nValueByKey(status.key, PlanStatus), value: status.key, selected: filterSelectedPlanStatus.includes(status.key), onWmOptionSelected: (event) => {
                                                    event.preventDefault();
                                                    filterSelectedPlanStatus.push(status.key);
                                                    setFilterSelectedPlanStatus(filterSelectedPlanStatus.map((planStatus) => planStatus));
                                                }, onWmOptionDeselected: (event) => {
                                                    event.preventDefault();
                                                    setFilterSelectedPlanStatus(filterSelectedPlanStatus.filter((val) => val != status.key));
                                                }, placeholder: undefined }, { children: getI18nValueByKey(status.key, PlanStatus) }), status.key));
                                        }) }), "plan-status") })), _jsx("div", Object.assign({ className: "filter-by" }, { children: _jsx(WmSelect, Object.assign({ multiple: true, id: "cohort-select-filter", label: associatedCohortsLabel, labelPosition: "none", placeholder: allAssociatedCohortsValue, allSelectedMessage: allAssociatedCohortsValue }, { children: (_a = sortedUniqueCohorts(uniqueCohorts)) === null || _a === void 0 ? void 0 : _a.map((uniqueCohortTitle) => {
                                            return (_jsx(WmOption, Object.assign({ "aria-label": uniqueCohortTitle, value: uniqueCohortTitle, selected: selectedCohorts.includes(uniqueCohortTitle), onWmOptionSelected: (event) => {
                                                    event.preventDefault();
                                                    selectedCohorts.push(uniqueCohortTitle);
                                                    setSelectedCohorts(selectedCohorts.map((cohort) => cohort));
                                                }, onWmOptionDeselected: (event) => {
                                                    event.preventDefault();
                                                    setSelectedCohorts(selectedCohorts.filter((val) => val != uniqueCohortTitle));
                                                }, placeholder: undefined }, { children: uniqueCohortTitle }), uniqueCohortTitle));
                                        }) }), "muliselect" +
                                        programPlansData +
                                        uniqueCohorts +
                                        resetFilters) }))] })), renderFilteredPlans.length === 0 ? (_jsxs("div", Object.assign({ className: "empty-tbl", role: "alert", "aria-live": "assertive", "aria-atomic": true }, { children: [_jsx("table", Object.assign({ className: "data-table", role: "grid", "aria-readonly": true }, { children: _jsx("thead", Object.assign({ className: "dataheader" }, { children: _jsxs("tr", Object.assign({ className: "dataheaderrow", role: "row" }, { children: [_jsx("th", { role: "columnheader", scope: "col" }), _jsx("th", { role: "columnheader", scope: "col" }), _jsx("th", { role: "columnheader", scope: "col" })] }), "headers") })) }), JSON.stringify(renderFilteredPlans)), renderEmptyView()] }))) : (_jsx("div", Object.assign({ className: "paper-card section-card" }, { children: _jsx("div", Object.assign({ className: "view-plans-list", id: "plans-list" }, { children: _jsxs("table", Object.assign({ className: "data-table", role: "grid", "aria-readonly": true }, { children: [_jsx("thead", Object.assign({ className: "dataheader" }, { children: _jsxs("tr", Object.assign({ className: "dataheaderrow", role: "row" }, { children: [_jsxs("th", Object.assign({ className: "plan-title-header", tabIndex: 0, role: "columnheader", scope: "col", "data-th": "Licensure Plan Title", onKeyPress: (e) => keyEventHandler(e, "Title", sortPlans), onClick: () => changeSorting("Title", sortPlans), "aria-sort": getAriaSortValue("Title", sortPlans) }, { children: [translate("app.licensurePlans.plan_title"), sortingIcon("Title", sortPlans)] })), _jsxs("th", Object.assign({ className: "plan-lastUpdated-header", tabIndex: 0, role: "columnheader", scope: "col", "data-th": "Updated At", onKeyPress: (e) => keyEventHandler(e, "updatedAt", sortPlans), onClick: () => changeSorting("updatedAt", sortPlans), "aria-sort": getAriaSortValue("updatedAt", sortPlans) }, { children: [translate("app.licensurePlans.last_updated"), sortingIcon("updatedAt", sortPlans)] })), _jsxs("th", Object.assign({ className: "plan-status-header", tabIndex: 0, role: "columnheader", scope: "col", "data-th": "Plan Status", onKeyPress: (e) => keyEventHandler(e, "Status", sortPlans), onClick: () => changeSorting("Status", sortPlans), "aria-sort": getAriaSortValue("Status", sortPlans) }, { children: [translate("app.licensurePlans.plan_status"), sortingIcon("Status", sortPlans)] })), _jsx("th", { children: _jsx("div", { className: "menu-opations" }) })] }), "headers") })), renderFilteredPlans.map((plan) => {
                                            return (_jsx("tbody", Object.assign({ className: "databody" }, { children: _jsxs("tr", Object.assign({ className: "datarow" }, { children: [_jsx("td", Object.assign({ className: "plan-name td-content", "data-td": "Plan Name" }, { children: _jsx(WmButton, Object.assign({ id: plan.title, buttonType: "textonly", onClick: (event) => {
                                                                    if (plan.status === "ARCHIVED") {
                                                                        setPlanId(plan.uuid);
                                                                    }
                                                                    else {
                                                                        editLicensurePlanHandler(plan);
                                                                    }
                                                                }, placeholder: undefined }, { children: plan.title })) })), _jsx("td", Object.assign({ className: "plan-updated td-content", "data-td": "Plan Updated" }, { children: _jsxs("div", { children: [format(new Date(plan.updatedAt), "MMM d, yyyy "), format(new Date(plan.updatedAt), "h:mm a"), _jsx("br", {}), "by ", plan.firstName + " " + plan.lastName] }) })), _jsx("td", Object.assign({ className: "plan-status td-content", "data-td": "Plan Status" }, { children: _jsx("span", Object.assign({ className: plan.status === "IN_USE"
                                                                    ? "in-use"
                                                                    : plan.status === "NOT_CONNECTED"
                                                                        ? "not-connected"
                                                                        : plan.status === "NOT_IN_USE"
                                                                            ? "not-in-use"
                                                                            : plan.status === "ARCHIVED"
                                                                                ? "archived"
                                                                                : "" }, { children: getI18nValueByKey(plan.status, PlanStatus) })) })), _jsx("td", { children: _jsx("div", Object.assign({ className: "actions-kebab td-content" }, { children: _jsxs(WmActionMenu, Object.assign({ "action-menu-type": "icon", tooltip: "Options", id: `action-menu-${plan.uuid}`, placeholder: undefined }, { children: [_jsx(WmMenuitem, Object.assign({ icon: "f18f", onClick: (event) => copyLicensurePlanHandler(plan), placeholder: undefined }, { children: translate("app.viewLicensurePlan.copy.plan") })), plan.status === "NOT_IN_USE" ? (_jsx(WmMenuitem, Object.assign({ icon: "f03c", "label-for-identical-buttons": `Archive ${plan.title}`, id: `archive-Licensure-plan-${plan.uuid}`, onClick: (event) => openArchiveModal(event, setSelectedLicensurePlanUuid(plan.uuid), setSelectedLicensurePlanTitle(plan.title), setIsArchiveButtonClicked(true), plan.title), placeholder: undefined }, { children: translate("app.viewLicensurePlan.archive.plan") }))) : plan.status === "ARCHIVED" ? (_jsx(WmMenuitem, Object.assign({ icon: "f6ea", "label-for-identical-buttons": `Restore ${plan.title}`, id: `restore-Licensure-plan-${plan.uuid}`, onClick: (event) => openArchiveModal(event, setSelectedLicensurePlanUuid(plan.uuid), setSelectedLicensurePlanTitle(plan.title), setIsArchiveButtonClicked(false), plan.title), placeholder: undefined }, { children: translate("app.viewLicensurePlan.restore.plan") }))) : plan.status === "NOT_CONNECTED" ? (_jsx(WmMenuitem, Object.assign({ icon: "f1c0", "label-for-identical-buttons": `Delete ${plan.title}`, id: `delete-Licensure-plan-${plan.uuid}`, onClick: (event) => openDeleteModal(event, setSelectedLicensurePlanUuid(plan.uuid), plan.title), placeholder: undefined }, { children: translate("app.viewLicensurePlan.delete.plan") }))) : ("")] })) })) })] })) }), plan.uuid));
                                        })] }), JSON.stringify(programPlansData)) })) })))] }))) : ("")) : ("")] })));
    };
    return isFetchingCurrentProgram ? (_jsx("div", Object.assign({ className: "loader -fullscreen" }, { children: _jsx("div", Object.assign({ className: "content content-loader", role: "alert" }, { children: "Loading..." })) }))) : (_jsxs("div", Object.assign({ className: "pagewrapper" }, { children: [_jsx(Header, { activeItem: "gateways" }), _jsxs("div", Object.assign({ className: "nav-main" }, { children: [_jsx(SideNav, { activeItem: "gateways" }), _jsxs("div", Object.assign({ className: "contentwrapper" }, { children: [_jsx("main", Object.assign({ id: "maincontent", className: "page-content-card" }, { children: viewPlan ? null : (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "paper-card" }, { children: [_jsx("div", Object.assign({ className: "program-header flex-row -justified -verticallycentered" }, { children: _jsxs("section", Object.assign({ className: "bread-crumbs" }, { children: [_jsx("a", Object.assign({ href: "", id: "go-to-previous-state", className: "link", onClick: navigateToLandingPage }, { children: _jsx("span", { children: translate("app.licensurePlan.gateways") }) })), _jsx("span", { children: currentProgramData.title })] })) })), _jsx("h1", Object.assign({ className: "heading-title" }, { children: currentProgramData.title }))] })), _jsx("div", Object.assign({ className: "tab-cmpt-main" }, { children: _jsx(SubTabWmComponent, { selectedTab: selectedTab, onWmTabSelected: onWmTabSelected, tabOption: tabOption }) })), _jsx(WmTabPanel, Object.assign({ id: "tab-one", tabId: "item-1", placeholder: undefined }, { children: _jsx(CohortCards, Object.assign({ orgUuid: localStorage.getItem("orgUuid"), programUuid: currentProgramData.uuid, programTitle: currentProgramData.title, institutionTitle: currentProgramData.institutionName, publishingCohortUuid: publishingCohortUuid, timelineUuid: timelineUuid }, props)) })), _jsx(WmTabPanel, Object.assign({ id: "tab-two", tabId: "item-2", placeholder: undefined }, { children: renderLicensurePlan() }))] })) })), _jsx(Footer, {})] }))] })), renderInformationModal(isLicensurePlanMaxLimitReached), renderDeleteLicensurePlanModal(openDeleteRequestModal), renderArchiveRestoreLicensurePlanModal(openArchiveRequestModal), viewPlan ? renderViewPlan() : null, _jsx(WmSnackbar, { notifications: snackNotifications, id: "licensurePlan-snacks", onWmSnackbarSnackFinished: (event) => finishedSnackHandler(event), placeholder: undefined })] })));
}
